export default __webpack_public_path__ + "images/HLF_Stor_logga_120_619afcbc706d80c312ae299d5773cf2a.svg";